const insuranceRequestLanding = require('./insuranceRequest/insuranceRequestLanding');
const insuranceRequestProductDetail = require('./insuranceRequest/insuranceRequestProductDetail');
const insuranceRequestSimulation = require('./insuranceRequest/insuranceRequestSimulation');
const insuranceRequestState = require('./insuranceRequest/insuranceRequestState');
const insuranceRequestWizard = require('./insuranceRequest/insuranceRequestWizard');
const insuranceRequestWizardStep3 = require('./insuranceRequest/insuranceRequestWizardStep3');
const insuranceRequestWizardStep4 = require('./insuranceRequest/insuranceRequestWizardStep4');
const insuranceRequestWizardStep5 = require('./insuranceRequest/insuranceRequestWizardStep5');

const insuranceRequestRelatedState = require('./insuranceRequestRelated/insuranceRequestRelatedState');
const insuranceRequestRelatedWizard = require('./insuranceRequestRelated/insuranceRequestRelatedWizard');
const insuranceRequestRelatedWizardStep3 = require('./insuranceRequestRelated/insuranceRequestRelatedWizardStep3');

const insuranceRequestRelatedRNCState = require('./insuranceRequestRelatedRNC/insuranceRequestRelatedRNCState');
const insuranceRequestRelatedRNCWizard = require('./insuranceRequestRelatedRNC/insuranceRequestRelatedRNCWizard');
const insuranceRequestRelatedRNCWizardStep3 = require('./insuranceRequestRelatedRNC/insuranceRequestRelatedRNCWizardStep3');

const InsurancesProfileDocumentation = require('./insurancesProfileDocumentation');
const insuranceChosenMortgage = require('./insuranceChosenMortgage');
const insuranceAssociatedMortgage = require('./insuranceAssociatedMortgage');

module.exports = {
    insuranceRequestLanding,
    insuranceRequestProductDetail,
    insuranceRequestSimulation,
    insuranceRequestState,
    insuranceRequestWizard,
    insuranceRequestWizardStep3,
    insuranceRequestWizardStep4,
    insuranceRequestWizardStep5,
    insuranceRequestRelatedState,
    insuranceRequestRelatedWizard,
    insuranceRequestRelatedWizardStep3,
    insuranceRequestRelatedRNCState,
    insuranceRequestRelatedRNCWizard,
    insuranceRequestRelatedRNCWizardStep3,
    InsurancesProfileDocumentation,
    insuranceChosenMortgage,
    insuranceAssociatedMortgage
};
